const styles = {
    logoContainer: {
        width: {xs: '100%', md: '45%'},
        display: "flex",
        justifyContent: {xs: 'space-around', md: "space-between"},
        alignItems: "center",
        my: {xs: '0.625rem', md: '20px'},
        minHeight: '200px',
        backgroundColor: '#E8E8E8',
    },
    formControl: {
        my: {xs: '0.5rem', md: '1rem'},
        width: '100%',
    },
    logoFormControl: {
        width: 'unset'
    },
    colorContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    colorFormControl: {
        width: "45%",
    },
    button: {
        fontSize: '0.625rem',
    }
}

export default styles;